import * as types from '../actions/action-types';
import initialState from './initial-state';

export default function forgotPasswordFormReducer(state = initialState.forgotPasswordForm, action) {
    switch (action.type) {
        case types.FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                isForgotPasswordSuccessful: true,
                forgotPasswordMessages: action.forgotPasswordMessages
            };
        case types.FORGOT_PASSWORD_ERROR:
            return {
                ...state,
                isForgotPasswordSuccessful: false,
                forgotPasswordMessages: action.forgotPasswordMessages
            };
        case types.LOAD_FORGOT_PASSWORD_FORM_SUCCESS:
            return {
                ...state,
                isFormLoadSuccessful: true,
                forgotPasswordFormData: action.forgotPasswordFormData,
                forgotPasswordMessages: []
            };
        case types.LOAD_FORGOT_PASSWORD_FORM_ERROR:
            return {
                ...state,
                isFormLoadSuccessful: false,
                forgotPasswordFormData: {},
                forgotPasswordMessages: []
            };
        case types.RESET_FORGOT_PASSWORD_FORM_STATE:
            return initialState.forgotPasswordForm;
        default:
            return state;
    }
}
